module.exports = __webpack_public_path__ + "media/images/pages/img_digest_area_01-27a81bb6efb9601086db441967a23a3b.jpg";